import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { OptOutType } from 'domains/opt-out';

export const getCatalogOptOut: QueryFunction<OptOutType, ['getCatalogOptOut']> = async () =>
  await api.get('/reseller/catalog').then((resp) => resp.data);
